// RequireAuth — guard для приватных маршрутов.
// loading → спиннер; unauthenticated → redirect на /login; authenticated → children.
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/lib/auth-context';

export interface RequireAuthProps {
  children: JSX.Element;
}

export function RequireAuth({ children }: RequireAuthProps): JSX.Element {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div
        className="flex min-h-screen items-center justify-center bg-canvas-white"
        role="status"
        aria-live="polite"
      >
        <div className="flex flex-col items-center gap-3">
          <div
            className="h-8 w-8 animate-spin rounded-full border-2 border-divider-gray border-t-blueprint-blue"
            aria-hidden="true"
          />
          <span className="text-sm text-muted-foreground">Загрузка…</span>
        </div>
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
